import React, { useEffect, useMemo } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import { translate } from 'components/Translation';
import CustomSelect from 'components/CustomSelect/CustomSelect';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/contactDetailsStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(style);
const getValue = (event: React.FormEvent<HTMLInputElement>) => (event.target as HTMLInputElement).value;

const ContactDetailsTab = (
	props: types.services.fixed.IContactDetails & {
		onChange: (name: keyof types.services.fixed.IContactDetails, value: string | boolean) => void;
		setNextStepDisabled: (nextStepDisabled: boolean) => void;
	}
) => {
	const { setNextStepDisabled, reqName, contactNo, bestTime, alreadyHaveNumber, workingNumber } = props;

	useEffect(() => {
		setNextStepDisabled(true);
	}, [setNextStepDisabled]);

	const workingNumberValid = useMemo(() => {
		return workingNumber.trim().length > 6 && /2[2-6]\d{6}$/.test(workingNumber);
	}, [workingNumber]);

	useEffect(() => {
		setNextStepDisabled(
			!(
				[reqName, contactNo, bestTime].every((value) => value.trim().length > 0) &&
				contactNo.trim().length > 7 &&
				(!alreadyHaveNumber || workingNumberValid)
			)
		);
	}, [setNextStepDisabled, reqName, contactNo, bestTime, alreadyHaveNumber, workingNumberValid]);

	const classes = useStyles();
	return (
		<>
			<GridContainer>
				<GridItem xs={12} md={8}>
					<CustomInput
						formControlProps={{ fullWidth: true }}
						labelText={translate('add.new.line.fixed.requesterName')}
						inputProps={{
							value: props.reqName,
							onChange: (event: any) => {
								props.onChange('reqName', event.target.value);
							},
						}}
					/>
				</GridItem>
			</GridContainer>
			<GridContainer>
				<GridItem xs={12} md={8}>
					<GridContainer justify="flex-start">
						<GridItem xs={8} md={6}>
							<CustomInput
								formControlProps={{ fullWidth: true }}
								labelText={translate('add.new.line.fixed.contactNumber')}
								inputProps={{
									value: props.contactNo,
									maxLength: 8,
									onChange: (event: React.FormEvent<HTMLInputElement>) =>
										props.onChange('contactNo', getValue(event).replace(/[^0-9]$/, '')),
								}}
							/>
						</GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
			<GridContainer>
				<GridItem xs={12} md={8}>
					<CustomSelect
						formControlProps={{ fullWidth: true }}
						inputLabelProps={{}}
						selectProps={{
							variant: 'standard',
						}}
						inputLabel={translate('add.new.line.bestTime')}
						items={[translate('Morning'), translate('Afternoon'), translate('Evening')].map((text) => ({
							value: text,
							label: text,
							itemProps: {},
						}))}
						value={props.bestTime}
						onChange={(event: any) => props.onChange('bestTime', event.target.value)}
					/>
				</GridItem>
			</GridContainer>
			<GridContainer>
				<GridItem xs={12} md={8}>
					<CustomCheckbox
						checked={props.alreadyHaveNumber}
						onClick={() => props.onChange('alreadyHaveNumber', !props.alreadyHaveNumber)}
						label={translate('add.new.line.alreadyHave')}
					/>
					<ConditionalRender
						show={props.alreadyHaveNumber}
						onTrue={() => (
							<div className={classes.workingNumber}>
								<CustomInput
									formControlProps={{ fullWidth: true }}
									labelText={translate('add.new.line.workingNumber')}
									inputProps={{
										value: workingNumber,
										maxLength: 8,
										onChange: (event: React.FormEvent<HTMLInputElement>) =>
											props.onChange('workingNumber', getValue(event).replace(/[^0-9]$/, '')),
									}}
									error={workingNumber.length && !workingNumberValid}
									helperText={
										workingNumber.length && !workingNumberValid
											? translate('error.invalid.omantel.number')
											: translate('add.new.line.workingNumber.description')
									}
								/>
							</div>
						)}
					/>
				</GridItem>
			</GridContainer>
		</>
	);
};

export default ContactDetailsTab;
